import script from "./FusionPaymentConfigView.vue?vue&type=script&setup=true&lang=js"
export * from "./FusionPaymentConfigView.vue?vue&type=script&setup=true&lang=js"

import "./FusionPaymentConfigView.vue?vue&type=style&index=0&id=d9948898&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9948898"]])

export default __exports__